import { notification } from "antd";
import { get, isNil, noop } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Spin from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { DOCUMENT_KINDS, SCREENS } from "utils/constants";
import useStaticDocumentDownload from "../../shared/useStaticDocumentDownload";
import View from "./View";

const EditStatic = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const { id } = useParams();
  const navigate = useNavigate();
  const download = useStaticDocumentDownload();
  const { data, loading } = useQuery(graphql.queries.STATIC_DOCUMENT, {
    variables: { where: { id } },
    fetchPolicy: "network-only",
  });
  const [updateDocument, { loading: saving }] = useMutation(
    graphql.mutations.UPDATE_STATIC_DOCUMENT,
    { onError: noop },
  );
  const document = get(data, "staticDocument");

  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path, {
      state: { kind: DOCUMENT_KINDS.STATIC },
    });

  const onSubmit = async (values) => {
    const { data: result } = await updateDocument({
      variables: { data: values, where: { id } },
    });
    if (isNil(get(result, "updateStaticDocument.id"))) {
      notification.error({ message: t("STATIC.FORM.FAILED") });
      return;
    }
    notification.success({ message: t("STATIC.FORM.SAVED") });
    cancel();
  };

  if (isNil(document)) return loading ? <Spin /> : null;

  return (
    <View
      key={document.id}
      document={document}
      onSubmit={onSubmit}
      cancel={cancel}
      onDownload={download}
      loading={saving}
    />
  );
};

export default EditStatic;
